import * as React from "react";

export interface UserInterface {
    name?:string;
    isReadOnly?:boolean;
};

// this is how it should be if we wanted to pass on the actions
//export interface UserState {
//    user?: UserInterface;
//    setUser?: ( user: UserInterface ) => void;
//}

export const UserContext = React.createContext<UserInterface | null>(null);
